import { ComponentProps } from "react";
import styled from "@emotion/styled";

export const PageLayout = styled((props: ComponentProps<"div">) => (
  <div {...props} />
))`
  margin: 2rem 3rem;
`;
